<template>
  <ModalFullScreen
    v-if="show_condition"
    :key="uniqueKey"
    v-model="dialog"
    content-class="add-foreign-offer-fullscreen"
    fullscreen
    no-click-animation
    persistent>
    <template
      #activator="{ on }">
      <sButton
        v-if="!!foreign_offer"
        class="mr-4 py-1 px-2 h11-links"
        data-qa="edit-external"
        icon="edit"
        @click="() => open(on) ">
        {{ $t('Common.Edit') }}
      </sButton>
      <MenuItem
        v-else
        :key="uniqueKey"
        class="menu-item h11-links"
        data-qa="tender-create-foreign-offer"
        icon="invite"
        :label="$t('Tenders.ToAddProposalFromExternalParticipant')"
        @click="() => open(on)"/>
    </template>
    <ComponentLayout id="create-foreign-offer">
      <template #breadcrumbs>
        <TenderBreadcrumbs
          :check-exit="checkChages"
          :current="!!foreign_offer ? $t('Tenders.EditProposalFromExternalParticipant') : $t('Tenders.AddingExternalParticipant')"
          :dialog.sync="dialog"/>
      </template>
      <template #main_content>
        <sIcon
          v-if="load"
          class="my-3"
          color="var(--white-color)"
          size="30"
          spin
          type="loading"/>
        <template v-else>
          <div class="width-100 h1-headline text-start my-9">
            {{ !!foreign_offer ? $t('Tenders.EditProposalFromExternalParticipant') : $t('Tenders.AddProposalFromExternalParticipant') }}
          </div>
          <div class="width-100 main__light_green rounded-lg pl-12 py-9">
            <sForm
              ref="form"
              :disabled="loading"
              label-position="top"
              label-width="100px"
              :model="offer"
              :rules="form_rules"
              style="width: 430px;">
              <div
                class="participant-info pb-5"
                data-qa="participant-info">
                <div
                  class="h5-headline text-start mb-5">
                  {{ $t('Tenders.InformationAboutParticipant') }}
                </div>
                <sFormItem
                  ref="org_usreou"
                  :label="$t('Tenders.ParticipantUsreouOrTIN')"
                  prop="usreou">
                  <sInput
                    clearable
                    data-qa="usreou"
                    :disabled="loading"
                    :max-length="4000"
                    max-rows="20"
                    :placeholder="$t('Tenders.ParticipantUsreou')"
                    :readonly="!!foreign_offer"
                    rows="1"
                    type="textarea"
                    :value.sync="offer.usreou"
                    @input="checkUsreou"/>
                </sFormItem>
                <sFormItem
                  :label="$t('Planning.CompanyName')"
                  prop="orgTitle">
                  <sInput
                    clearable
                    data-qa="orgTitle"
                    :disabled="loading"
                    :max-length="4000"
                    max-rows="20"
                    :placeholder="$t('Planning.CompanyName')"
                    :readonly="lock_org_title || !!foreign_offer"
                    rows="1"
                    type="textarea"
                    :value.sync="offer.orgTitle"/>
                </sFormItem>
                <sFormItem
                  :label="$t('Tenders.EMailAddress')"
                  prop="orgMail">
                  <sInput
                    clearable
                    data-qa="orgMail"
                    :disabled="loading"
                    :max-length="4000"
                    max-rows="20"
                    :placeholder="$t('Tenders.EMailAddress')"
                    :readonly="!!foreign_offer"
                    remove-new-line
                    trim
                    :value.sync="offer.orgMail"
                    @input="checkContactMail"/>
                </sFormItem>
                <sFormItem
                  :label="$t('Tenders.ContactPersonParticipant')"
                  prop="contactName">
                  <sInput
                    clearable
                    data-qa="contactName"
                    :disabled="loading"
                    :max-length="4000"
                    max-rows="20"
                    :placeholder="$t('Common.Initials')"
                    :readonly="lock_contact || !!foreign_offer"
                    rows="1"
                    type="textarea"
                    :value.sync="offer.contactName"/>
                </sFormItem>
              </div>
              <div
                class="general-offer-info pb-5"
                data-qa="general-offer-info">
                <div
                  class="h5-headline text-start black--text pb-4">
                  {{ $t('Tenders.GeneralProposalDataFromExternalParticipant') }}
                </div>
                <div>
                  <sFormItem
                    v-if="choose_curr"
                    :label="$t('Tenders.ChooseCurrencyOfOffer')"
                    prop="currency.code">
                    <sSelect
                      class="width-100"
                      data-qa="offer-currency"
                      :disabled="loading"
                      filterable
                      lots
                      :placeholder="$t('Tenders.ChooseCurrencyOfOffer')"
                      :value.sync="offer.currency"
                      value-key="code">
                      <sOption
                        v-for="item in currencies"
                        :key="`currency-${item.code}`"
                        :data-qa="`currency-${item.code}`"
                        :label="item.title"
                        :value="item"/>
                    </sSelect>
                  </sFormItem>
                  <OfferCriterion
                    v-for="(item, i) in offer.tenderCriteria"
                    :key="item.criterion.id + '-' + i"
                    :all_criteria="offer.tenderCriteria"
                    :criterion="item.criterion"
                    :disabled="loading"
                    :form_prop="`tenderCriteria[${i}].value`"
                    :value.sync="item.value"/>
                  <sFormItem
                    class="width-100"
                    :label="$t('Tenders.AdditionalInformationToOffer')"
                    :prop="`comment`">
                    <sInput
                      clearable
                      data-qa="lot-comment"
                      :disabled="loading"
                      :max-length="4000"
                      max-rows="20"
                      :placeholder="$t('Common.EnterText')"
                      rows="1"
                      type="textarea"
                      :value.sync="offer.comment"/>
                  </sFormItem>
                  <ImportBlock
                    :create-file-handler="createFileHandler"
                    data-qa="import-offer-docs"
                    :disabled="loading"
                    :files.sync="offer.attachments"
                    files-types
                    inline-style="width: 430px">
                    <template #label>
                      <div class="h7-text black--text pb-1">
                        {{ $t('Common.AddDocuments') }}
                        <span class="secondary__green_not_active--text">
                          ({{ smallFirstLetter($t('Tenders.NotNecessarily')) }})
                        </span>
                      </div>
                    </template>
                  </ImportBlock>
                </div>
              </div>
              <div
                class="offer-lots"
                data-qa="offer-lots">
                <div
                  class="h5-headline text-start black--text mb-5">
                  {{ $t('Tenders.SelectedLots') }}
                </div>
                <template
                  v-for="(item, index) in offer.lots">
                  <ForeignOfferLot
                    :key="item.lotId + '' + index"
                    :currency="offer.currency"
                    :disabled="loading "
                    :index="index"
                    :lot="item"
                    :lots="available_lots"
                    :lots_count="offer.lots.length"
                    :tender_criteria="offer.tenderCriteria"
                    :vat-include="tender.vatInclude"
                    @copyCriteria="copyCriteria"
                    @deleteLot="deleteLot"/>
                  <sDivider
                    v-if="index != offer.lots.length - 1"
                    :key="item.lotId + '' + index + '-divider'"
                    class="my-5 "
                    color=" var(--color-main-green)"
                    style="width: 630px;"/>
                </template>
                <sButton
                  v-if="available_lots.length && !offer.lots.some(el => !el.lotId)"
                  class="px-2 h10-links mt-5"
                  data-qa="btn-add-lot"
                  :disabled="loading"
                  icon="plus"
                  icon-size="8px"
                  small
                  type="text"
                  @click="addLot">
                  {{ $t('Tenders.ChooseAnotherLot') }}
                </sButton>
              </div>
            </sForm>
          </div>
        </template>
      </template>
      <template #footer>
        <ComponentFooter
          key="foreign-offer-footer"
          ref="footer"
          :back="cancel"
          :back_btn="$t('Common.Cancel')">
          <template #next>
            <sButton
              class="send-foreign-offer-btn"
              data-qa="send-foreign-offer-btn"
              :disabled="loading"
              :loading="loading"
              @click="sendOffer">
              {{ !!foreign_offer ? $t('Tenders.EditOffer') : $t('Tenders.AddOffer') }}
            </sButton>
          </template>
        </ComponentFooter>
      </template>
    </ComponentLayout>
  </ModalFullScreen>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'
import ComponentLayout from 'pages/templates/ComponentLayout.vue'
import ImportBlock from 'components/common/blocks/ImportBlock.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import ComponentFooter from 'components/common/blocks/ComponentFooter.vue'
import OfferCriterion from 'components/tenders/tender page/foreign offer/OfferCriterion.vue'
import ForeignOfferLot from 'components/tenders/tender page/foreign offer/ForeignOfferLot.vue'

import ModalFullScreen from 'components/common/elements/ModalFullScreen.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

import { debounce } from 'toolkit/utils/util'
import isCriterionDisplayed from 'utils/criterionDisplay'
import { ForeignOfferFile } from '@/types/commonFile.js'
import { rejectionMessage } from '@/helpers/emailRejections.js'
import { modalMixin, tenderMixin } from 'mixins'
import foreignBidErrorMixin from 'mixins/foreignBidErrorMixin.js'

export default {
  name: 'foreignOffer',
  mixins: [ modalMixin, tenderMixin, foreignBidErrorMixin ],
  data() {
    const that = this
    return {
      dialog: false,
      loading: false,
      organisation: {},
      default_offer: {
        tenderId: 0,
        usreou: '',
        orgTitle: '',
        orgMail: '',
        contactName: '',
        currency: {},
        comment: '',
        tenderCriteria: [],
        lots: [],
        attachments: [],
      },
      default_lot: {
        lotId: 0,
        price: 0,
        quantity: 0,
        comment: '',
        criteria: [],
        tender_lot: {}
      },
      empty_offer: null,
      offer: {},
      lots_criteria: [],
      tenders_criteria: [],
      currencies: [],
      criteryCard: null,
      load: false,
      lock_org_title: false,
      lock_contact: false,
      form_rules: {
        orgTitle: [
          {
            type: 'string',
            required: true,
            trigger: 'change',
            message: this.$t('Validate.Required')
          },
          {
            type: 'string',
            required: true,
            trigger: 'change',
            max: 150,
            message: this.$t('Validate.maxLength', {number: 150, type: this.$tc('Common.characters', 10) })
          }
        ],
        contactName: [
          {
            type: 'string',
            required: true,
            trigger: 'change',
            message: this.$t('Validate.Required')
          },
          {
            type: 'string',
            required: true,
            trigger: 'change',
            max: 4000,
            message: this.$t('Validate.maxLength', {number: 4000, type: this.$tc('Common.characters', 10) })
          }
        ],
        orgMail: [
          {
            type: 'string',
            required: true,
            trigger: 'change',
            message: this.$t('Validate.Required')
          },
          /*{
            type: 'string',
            required: true,
            trigger: 'change',
            min: 2,
            message: this.$t('Validate.minLength', {number: 2, type: this.$tc('Common.characters', 2) })
          },*/
          {
            type: 'string',
            required: true,
            trigger: 'change',
            max: 254,
            message: this.$t('Validate.maxLength', {number: 254, type: this.$tc('Common.characters', 4) })
          },
          {
            type: 'string',
            required: true,
            trigger: 'blur',
            pattern: /^\s*([A-Za-z0-9_\-.'])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,10})\s*$/,
            message: this.$t('Tenders.MailRules', {mail: ''})
          },
          {
            type: 'string',
            trigger: 'change',
            validator(rule, value, callback) {
              const chechItems = [{email: value}]
              const resultCheck = that.$_checkRuEmailDomen(chechItems)

              if (resultCheck[0].blockDomen) {
                callback(new Error(that.$t('Common.mailDomenBlocked')))
              }
              callback()
            },
          }
        ],
        usreou: [
          {
            type: 'string',
            required: true,
            trigger: 'change',
            message: this.$t('Validate.Required')
          },
          {
            type: 'string',
            required: true,
            trigger: 'change',
            min: 8,
            message: this.$t('Validate.minLength', {number: 8, type: this.$tc('Common.characters', 8) })
          },
          {
            type: 'string',
            required: true,
            trigger: 'change',
            max: 50,
            message: this.$t('Validate.maxLength', {number: 50, type: this.$tc('Common.characters', 50) })
          },
          {
            type: 'string',
            required: true,
            trigger: 'change',
            validator(rule, value, callback) {
              if (that.organisation?.isOrgInStopList) {
                callback(new Error(that.$t('StopLists.AddedToStopList', {participant: that.organisation.name})) )
              }
              callback()
            },
          },
          {
            type: 'string',
            required: true,
            trigger: 'change',
            validator(rule, value, callback) {
              if (that.foreign_offer) {
                callback()
                return
              }
              const hasExistBidForLot = (that.tender?.bids || [])
                .some(bid =>
                  bid.bidderInfo.usreou === value
                )

              if (hasExistBidForLot) {
                const participant = that.organisation?.name ? `${value} (${that.organisation.name})` : value
                callback(new Error(that.$t('Validate.usreouExistInBid', {participant})))
              }
              callback()
            },
          }
        ],
        'currency.code': [{
          type: 'number',
          required: true,
          trigger: 'change',
          message: this.$t('Validate.Required')
        }],
      }
    }
  },
  props: {
    tender: {
      type: Object,
      required: true
    },
    foreign_offer: {
      type: Object
    },
  },
  computed: {
    uniqueKey() {
      return `key-${this.show_condition}-${!!this.foreign_offer}`
    },
    choose_curr() {
      return !!this.tender.currencyOwner
    },
    currency() {
      return this.tender.currency
    },
    available_lots() {
      if (!this.tender || !this.tender.lots || !this.offer || !this.offer.lots) {
        return []
      }
      return this.tender.lots.filter(lot => !this.offer.lots.some(el => el.lotId == lot.lotId))
    },
    show_condition() {
      return this.tender.tenderStatus.id == this.statuseKeys.BID_ANALYSIS  && this.$can('have', 'ForeignSupplierBid')
    }
  },
  methods: {
    lotRules(lot, index) {
      const prefix = `lots[${index}]`
      const rules = this.form_rules

      rules[`${prefix}.lotId`] = {
        type: 'number',
        required: true,
        trigger: 'change',
        min: 1,
        message: this.$t('Validate.Required'),
      }
      rules[`${prefix}.price`] = {
        type: 'number',
        required: true,
        trigger: 'change',
        min: 0.01,
        message: this.$t('Validate.Required'),
      }
      rules[`${prefix}.quantity`] = {
        type: 'number',
        required: true,
        min: 0.001,
        trigger: 'change',
        message: this.$t('Validate.Required'),
      }
      rules[`${prefix}.comment`] = [{
        type: 'string',
        trigger: 'change',
        max: 4000,
        message: this.$t('Validate.maxLength', {number: 4000, type: this.$tc('Common.characters', 10) })
      }]

      lot.criteria.forEach((crit, ind) => {
        this.getCriteriaRule(crit, ind, `${prefix}.criteria`, () => (this.offer.lots[index]?.criteria || []).concat(this.offer.tenderCriteria))
      })
      return rules
    },
    getCriteriaRule (crit, index, prefix, getAllCriteria) {
      const that = this

      this.form_rules[`${prefix}[${index}].value`] = {
        required: crit.criterion.required,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!isCriterionDisplayed(crit.criterion, getAllCriteria())) {
            return callback()
          }
          if (crit.criterion.criterionControlType == 'NUMERIC_INPUT') {
            if (!value) {
              return callback(new Error(that.$t('Validate.Required')))
            }
            let less = crit.criterion.minValue && value < +crit.criterion.minValue,
              more = crit.criterion.maxValue !== null && crit.criterion.maxValue !== undefined && value > +crit.criterion.maxValue,
              is_wrong = less || more,
              result =  is_wrong ?
                `${that.$t('Tenders.EnterValue')}
                  ${(less ? `${that.$t('Purchasing.From')}  ${that.formSum(crit.criterion.minValue)}` : '')}
                  ${(more ? `${that.$t('Common.till')}  ${that.formSum(crit.criterion.maxValue)}` : '')}`
                : ''
            if (result) {
              return callback(new Error(result))
            }

          } else if (crit.criterion.criterionControlType != 'CALCULATED' && !value) {
            return callback(new Error(that.$t('Validate.Required')))
          }
          callback()
        }
      }
    },
    checkChages() {
      return !this.$_.isEqual(this.offer, this.empty_offer)
    },
    async open() {
      setTimeout(() => {
        this.dialog = true
      }, 200)

      this.load = true

      if (!this.criteryCard) {
        this.criteryCard = await this.$store.dispatch('infoAboutCriterionCard', {save: true, id: this.tender.criteriaCard})

        this.tenders_criteria  = []
        this.lots_criteria = []

        this.criteryCard?.criterias?.forEach(el => {
          if (el.criterionBindingLevel == 'LOT') {
            this.lots_criteria.push(el)
          } else {
            this.tenders_criteria.push(el)
          }
        })
      }
      let mapCriteria = (criterion, array = []) => {
        let crit = array?.find(el => el.code?.trim() == criterion.criterionCode?.trim()),
          type = criterion.criterionControlType,
          value = ''
        if (crit) {
          if ( type == 'DICTIONARY') {
            value = criterion.dictionaryValues.find(dict => dict.title == crit.value).id
          } else if (type == 'NUMERIC_INPUT' || type == 'CALCULATED') {
            value = +(crit.value.replace(',', '.'))
          } else {
            value = crit.value
          }
        } else {
          value = criterion.fixedValue || (type == 'NUMERIC_INPUT' || type == 'CALCULATED' ? 0 : '')
        }

        return {
          value,
          criterion
        }
      }

      if (this.foreign_offer) {
        let foreign_offer = this.tender?.bids
          .filter(bid => bid.bidderInfo.usreou == this.foreign_offer.bidderInfo.usreou)

        let lots = []
        if (foreign_offer?.length) {
          foreign_offer.map(offer =>
            offer.bidDetails.map(bid => {
              const lotItem = {
                lotId: bid.lotId,
                price: bid.currencyPrice,
                quantity: bid.quantity,
                comment: bid.additionalInfo,
                criteria: this.lots_criteria.map(crit => mapCriteria(crit, bid.criteria)),
                tender_lot: this.tender.lots.find(lot => lot.lotId == bid.lotId),
                bid: bid
              }
              lots.push(lotItem)

              this.lotRules(lotItem, lots.length - 1)
            }
            )
          )
        }
        this.empty_offer = {
          bid: foreign_offer[0],
          usreou: foreign_offer[0].bidderInfo.usreou,
          orgTitle: foreign_offer[0].bidderInfo.organizationName,
          orgMail: foreign_offer[0].bidderInfo.email,
          contactName: foreign_offer[0].bidderInfo.fullName,
          currency: this.$_.cloneDeep(this.tender.currency),
          comment: foreign_offer[0].remark,
          tenderCriteria: this.tenders_criteria.map(crit => mapCriteria(crit, foreign_offer[0].criteria)),
          lots: lots,
          attachments: foreign_offer[0].attachments?.map(doc => ({
            ...doc,
            id: doc.id,
            fileName: doc.title,
            deleted: false
          })) || [],
        }
      } else if (!this.empty_offer) {
        if (this.choose_curr) {
          this.currencies = await this.$store.dispatch('setCurrencies')
        }

        let empty_offer = this.$_.cloneDeep(this.default_offer)

        empty_offer.currency = this.$_.cloneDeep(this.tender.currency)
        empty_offer.lots =  [this.$_.cloneDeep(this.default_lot)]

        this.$set(empty_offer, 'tenderCriteria', this.tenders_criteria.map(item => mapCriteria(item)))
        this.$set(empty_offer.lots[0], 'criteria', this.lots_criteria.map(item => mapCriteria(item)))

        this.empty_offer = this.$_.cloneDeep(empty_offer)
      }
      this.offer = this.$_.cloneDeep(this.empty_offer)

      let new_lot = this.$_.cloneDeep(this.default_lot)
      this.$set(new_lot, 'criteria', this.lots_criteria.map(elem => ({
        value: elem.fixedValue || '',
        criterion: elem,
      })))
      this.lotRules(new_lot, 0)

      this.offer.tenderCriteria.forEach((crit, index) => {
        this.getCriteriaRule(crit, index, 'tenderCriteria', () => this.offer.tenderCriteria)
      })
      this.load = false
      if (!this.foreign_offer) {
        this.$root.$emit('closeSnackbar')
      }
      this.$nextTick(() => {
        this.$refs.form?.clearValidate()
      })
    },
    cancel(close) {
      if (!close && this.checkChages()) {
        this.$root.$emit('showExitConfirmation', { submitExit: this.close })
      } else {
        this.close()
      }
    },
    close() {
      this.lock_org_title = false
      this.lock_contact = false
      this.dialog = false
      this.$emit('hideActions')
    },
    checkMail(value) {
      return value.match(/(?<mail>[\w.-]+@[\w.-]+\.[a-zA-Z]+)/gm)
    },
    checkUsreou: debounce(function (val) {
      if (!val) {
        if (this.lock_org_title) {
          this.offer.orgTitle = ''
        }
        this.lock_org_title = false
        return
      }
      let matches_usreou = val.split(/\b/)
      if (matches_usreou && matches_usreou?.length == 1) {
        this.$store.dispatch('getOrganizationInfo', matches_usreou[0]).then(res => {
          if (!res || res.length != 1) {
            if (this.lock_org_title) {
              this.offer.orgTitle = ''
              this.organisation = {}
            }
            this.lock_org_title = false
            return
          }
          this.offer.orgTitle = res[0].name
          this.organisation = res[0]
          this.lock_org_title = true
          this.$refs.org_usreou.$emit.apply(this.$refs.org_usreou, ['s.form.change'].concat(val))
        })
      }
    }, 500),
    checkContactMail: debounce(async function (val) {
      if (!val) {
        if (this.lock_contact) {
          this.offer.contactName = ''
        }
        this.lock_contact = false
        return
      }
      let matches_mail = this.checkMail(val)

      if (matches_mail && matches_mail?.length == 1) {
        await api.getParticipants(matches_mail)
          .then(({ users: res, rejected }) => {
            if (rejected.length) {
              this.$notice.error({
                title: this.$t('Common.ErrorTitle'),
                message: rejectionMessage(rejected[0], this.$t.bind(this)),
                duration: 10,
              })
            }
            if (res.length != 1) {
              if (this.lock_contact) {
                this.offer.contactName = ''
              }
              this.lock_contact = false
              return
            }
            this.offer.contactName = res[0].userName
            this.lock_contact = true
          })
      }
    }, 500),
    createFileHandler(file) {
      return new ForeignOfferFile(file)
    },
    addLot() {
      let new_lot = this.$_.cloneDeep(this.default_lot)
      this.$set(new_lot, 'criteria', this.lots_criteria.map(elem => ({
        value: elem.fixedValue || '',
        criterion: elem,
      })))
      this.lotRules(new_lot, this.offer.lots?.length)
      this.offer.lots.push(new_lot)
    },
    deleteLot(id, index) {
      this.offer.lots.splice(index, 1)
    },
    copyCriteria(params) {
      this.offer.lots.forEach((lot, lotIndex) => {
        if (params.all) {
          this.$set(this.offer.lots[lotIndex], 'criteria', this.$_.cloneDeep(params.criteria))
        } else {
          params.criteria.forEach(criteriaItem => {
            const currentCriteria = this.offer.lots[lotIndex].criteria.find(i => i.criterion.id === criteriaItem.criterion.id)
            if (currentCriteria && !currentCriteria.value) {
              currentCriteria.value = criteriaItem.value
            }
          })
        }
      })
    },
    sendOffer() {
      this.$refs.form.validate().then(async () => {
        this.loading = true
        let offer = this.offer,
          model = {
            bid: {
              tenderId: this.tender.tenderId,
              currencyId: offer.currency.code || 0,
              comment: offer.comment,
              tenderCriteria: offer.tenderCriteria.map(crit => ({
                value: '' + (crit.value || ''),
                criterionId: crit.criterion?.criterionCode?.trim(),
              })),
              lots: offer.lots?.map(lot => ({
                lotId: lot.lotId || 0,
                rows: [{
                  rowId: lot.rowId || lot.tender_lot?.rowId || 0,
                  analogId: lot.analogId || 0,
                  itemId: lot.itemId || lot.tender_lot.itemId || 0,
                  price: lot.price || 0,
                  quantity: lot.quantity || 0,
                  reducedPrice: lot.reducedPrice || 0,
                  paymentCondition: lot.paymentCondition || '',
                  deliveryCondition: lot.deliveryCondition || '',
                  deliveryTerm: lot.deliveryTerm || 0,
                  warrantyYears: lot.warrantyYears || 0,
                  comment: lot.comment || '',
                  bidRowId: lot.bid?.idBidRow || 0,
                  criteria: lot.criteria.map(crit => ({
                    value: '' + (crit.value || ''),
                    criterionId: crit.criterion?.criterionCode?.trim(),
                  })),
                }]
              })),
              attachments: offer.attachments?.map(file => ({
                id: file.id || 0,
                fileName: file.uploaded?.fileName || file.fileName || '' ,
                deleted: false
              })).filter(el => el.id)
            },
            foreignSupplier: {
              usreou: offer.usreou || '',
              orgTitle: offer.orgTitle || '',
              orgMail: offer.orgMail.replace(/[\r\n]/gm, '') || '',
              tenderId: this.tender.tenderId,
              contactName: offer.contactName || ''
            }
          }
        await api.submitForeignSupplierBid(model, offer.attachments?.map(file => file.file).filter(el => el))
          .then((res) => {
            if (res?.success) {
              this.$Modal.info({
                title: this.$t('Tenders.SuccessfullyAddedOfferFromExternalBidder', {nubmer: this.tender.tenderNumber}),
                content: this.$t('Tenders.ExternalParticipantOfferWillBeMarked'),
                closable: false,
                okText: this.$t('Common.Close'),
                onOk: () => {
                  this.$root.$emit('tenderUpdate', true)
                  this.cancel(true)
                },
                width: 736
              })
            } else {
              throw res
            }
          })
          .catch(error => {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: this.$_foreignBidErrorMessage(error, this.tender.lots),
              duration: 10,
            })
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  },
  components: {
    MenuItem,
    ImportBlock,
    OfferCriterion,
    ComponentLayout,
    ComponentFooter,
    ForeignOfferLot,
    ModalFullScreen,
    TenderBreadcrumbs,
  }
}
</script>
<style lang="scss" scoped>
  .v-dialog__content,
  .v-dialog__content--active {
    z-index: 1100 !important;
  }
  .tender-create-foreign-offer {
    &.list-item {
      min-height: 40px;

      cursor: pointer;
      &:hover {
        background-color: var(--v-secondary__green_chosen-base);
      }
    }
  }
</style>
